// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Video-module--wrapper--s2Hsh","root":"Video-module--root--3A1js","preview":"Video-module--preview--3BsNi","playButton":"Video-module--playButton--1yQRN"};